import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { courtDocuments } from '../data/documents';
export function CourtDocuments() {
  return <section id="court-documents" aria-labelledby="court-documents-heading" className="mt-16 border-t-2 border-ink pt-8" data-id="element-19" data-mp="v96o18l5klki">
      <h2 id="court-documents-heading" className="font-serif text-[26px] font-bold leading-[1.25] tracking-[-0.01em] text-ink sm:text-[30px]" data-id="element-20" data-mp="mf20oz589s9q">
        Court Documents &amp; Records
      </h2>
      <p className="mt-3 font-serif text-[17px] leading-[1.7] text-ink-soft" data-id="element-21" data-mp="1e71589wfq3dz">
        The following documents are provided as supporting records for this report.
      </p>

      <ul className="mt-8 grid gap-px bg-rule sm:grid-cols-2" data-id="element-22" data-mp="155t6jqq0b0jd">
        {courtDocuments.map(document => <li key={document.id} className="flex flex-col bg-paper p-6" data-id="element-23" data-mp="3kwo4568e55u2">
            <p className="font-sans text-[10.5px] font-semibold uppercase tracking-[0.16em] text-ink-faint" data-id="element-24" data-mp="3kzk0wr8i5ogx">
              {document.type}
            </p>
            <h3 className="mt-3 font-serif text-[19px] font-semibold leading-[1.3] text-ink" data-id="element-25" data-mp="oadt03stdv9c">
              {document.title}
            </h3>

            <div className="mt-3 space-y-1" data-id="element-26" data-mp="kadhaqx3ny5z">
              <p className="font-sans text-[13px] leading-[1.55] text-ink-muted" data-id="element-27" data-mp="y8tkw8zo18jw">{document.court}</p>
              {document.caseNumber && <p className="font-sans text-[13px] leading-[1.55] text-ink-muted" data-id="element-28" data-mp="tas4xwxjdpcn">
                  {document.caseNumber}
                </p>}
              <p className="font-sans text-[13px] leading-[1.55] text-ink-faint" data-id="element-29" data-mp="135tv8w3jsxgt">{document.date}</p>
            </div>

            {document.description && <p className="mt-3 font-sans text-[13px] leading-[1.6] text-ink-soft" data-id="element-30" data-mp="1bz6ro80tmh7n">
                {document.description}
              </p>}

            <a href={document.url ?? '#'} {...document.url ? {
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {}} className="mt-auto inline-flex w-fit items-center gap-2 border-b border-ink pb-1 pt-6 font-sans text-[11.5px] font-semibold uppercase tracking-[0.14em] text-ink transition-colors duration-150 ease-out hover:border-ink-faint hover:text-ink-muted focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink focus-visible:ring-offset-2" data-id="element-31" data-mp="1qwz60wumszk9">
              View document
              <ArrowRightIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-32" data-mp="2cniglt63sjrz" />
            </a>
          </li>)}
      </ul>
    </section>;
}